import { render, staticRenderFns } from "./AccountsReceivableStatementDetails.vue?vue&type=template&id=10ea992e&scoped=true"
import script from "./AccountsReceivableStatementDetails.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableStatementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea992e",
  null
  
)

export default component.exports